import React from 'react';

import classes from './Footer.module.scss';
import {
  stripePrivacyPolicyLink,
  stripeTermsOfUseLink,
} from '../../../constants/externalLinks';
import { ReactComponent as StripeLogo } from '../../../../shared/assets/image/stripe-logo.svg';

const Footer = () => {
  return (
    <div className={classes.container}>
      <div className={classes.logo}>
        <p>Powered by</p>
        <StripeLogo />
      </div>
      <div className={classes.privacyLinks}>
        <a className={classes.link} href={stripeTermsOfUseLink}>
          Terms
        </a>
        <p>·</p>
        <a className={classes.link} href={stripePrivacyPolicyLink}>
          Policy
        </a>
      </div>
    </div>
  );
};

export { Footer };
